import React from 'react';
import {connect} from 'react-redux';
import {changeDeviceSettings} from '../../../common/device/actions';

class KitchenPrint extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        kitchenPrint: React.PropTypes.bool,
        changeDeviceSettings: React.PropTypes.func,
        kitchenItemsPrintSeparate: React.PropTypes.bool
    };

    render() {
        const {kitchenPrint, changeDeviceSettings, msg} = this.props;

        return (
            <div className="table-row">
              <div className="table-cell" style={{width: '55.55%'}}>
                <div className="boxBtn text-left text-black">
                    <div className="boxBtn-inner">
                      <div className="settings-name">
                        <span className="settings-name-name">{msg.settings.kitchenPrint.title}</span>
                        <span className="settings-name-info">{msg.settings.kitchenPrint.subtitle}</span>
                      </div>
                    </div>
                </div>
              </div>
              <div className="table-cell" style={{width: '44.44%'}}>
                    <div className="switch">
                        <div className={`switch-option text-l ${kitchenPrint ? 'active' : ''} color-greenLight`}
                             onClick={() => changeDeviceSettings('kitchenPrint', true)}>
                            <div className="switch-inner">
                                <span>{msg.settings.on}</span>
                            </div>
                        </div>
                        <div className={`switch-option text-l ${kitchenPrint ? '' : 'active'} color-red`}
                             onClick={() => changeDeviceSettings('kitchenPrint', false)}>
                            <div className="switch-inner">
                                <span>{msg.settings.off}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    kitchenPrint: state.device.kitchenPrint,
    kitchenItemsPrintSeparate: state.device.kitchenItemsPrintSeparate,
}), {changeDeviceSettings})(KitchenPrint);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/KitchenPrint.js